import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
// Modules
// import ecommerceStoreModule from '@/views/apps/e-commerce/eCommerceStoreModule'
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import dashboard from './dashboard'
import chart from './chart'
import filters from './filters'
import auth from './auth'
import countryCodes from './country-codes'
import campaigns from './campaigns'
import countryList from "./country-list"
import languageList from "./language-list";
import filterV2 from "./filterV2"
import adinSettings from "./adin-settings";

Vue.use(Vuex)

const vuexLocal = new VuexPersistence({
  storage: window.localStorage
})

const initialState = {
  app: app.state,
  appConfig: appConfig.state,
  verticalMenu: verticalMenu.state,
  dashboard: dashboard.state,
  chart: chart.state,
  filters: filters.state,
  auth: auth.state,
  countryCodes: countryCodes.state,
  campaigns: campaigns.state,
  countryList: countryList.state,
  languageList: languageList.state,
  filterV2: filterV2.state,
  adinSettings: adinSettings.state,
}

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    campaigns,
    dashboard,
    chart,
    filters,
    auth,
    countryCodes,
    countryList,
    languageList,
    filterV2,
    adinSettings,
  },
  mutations: {
    RESET_STORE: (state) => {
      //https://github.com/vuejs/vuex/issues/1118
      Object.keys(state).forEach(key => {
        Object.assign(state[key], initialState[key])
      })
    },
  },
  actions: {
    resetAllStore({ commit }) {
      commit('RESET_STORE')
    },
  },
  strict: process.env.DEV,
  plugins: [vuexLocal.plugin]
})
